export enum VehicleSizesEnum {
  vehicle_motorcycle = 'vehicle-motorcycle',
  vehicle_car = 'vehicle-car',
  vehicle_small_van = 'vehicle-small-van',
  vehicle_large_van = 'vehicle-large-van',
}
